var map = {
	"./上岗考勤.png": 28095,
	"./在线抢单.png": 52418,
	"./安全教育.png": 71006,
	"./排队预约.png": 81605,
	"./接单执行.png": 16352,
	"./立即下载.png": 46913,
	"./节点上报.png": 17746,
	"./行业应用.png": 26868,
	"./车辆报修.png": 84029,
	"./违规处理.png": 7068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66677;